import { inject } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { Router, Routes } from '@angular/router';
import { doctorGuard } from './guards/doctor.guard';
/**
 * Guard de autenticación funcional que protege las rutas de la aplicación.
 * Permite si está logeado, redirige a /login si no lo está.
 */
export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true; // Acceso permitido
  }

  // Redirigir al login si no está autenticado
  return router.parseUrl('/login');
};

/**
 * Guard para proteger las rutas públicas (login, forgot-password).
 * Permite si NO está logeado, redirige a la ruta principal si ya lo está.
 */
export const publicGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return true; // Acceso permitido
  }

  // Redirigir a la ruta principal ('/calendario-rentas') si ya está logeado
  return router.parseUrl('/calendario-rentas');
};

// **Se eliminan: authReception y roleGuard**

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login.page').then((m) => m.LoginPage),
    canActivate: [publicGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./auth/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
    canActivate: [publicGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
    canActivate: [publicGuard],
  },
  {
    path: 'calendario-rentas',
    loadComponent: () => import('./pages/rentas/calendario-rentas.page').then((m) => m.CalendarioRentasPage),
    canActivate: [authGuard],
  },
  {
    path: 'catalogos-rentas',
    loadComponent: () => import('./pages/rentas/rentas-catalogos.page').then((m) => m.RentasCatalogosPage),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [authGuard],
  },
  {
    path: 'hospital-checkout-history/:type',
    loadComponent: () =>
      import('./pages/hospital-checkout-history/hospital-checkout-history.page').then(
        (m) => m.HospitalCheckoutHistoryPage,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'pacientes',
    loadComponent: () => import('./pages/pacientes/pacientes.page').then((m) => m.PacientesPage),
    canActivate: [authGuard],
  },
  {
    path: 'staff',
    loadComponent: () => import('./pages/staff/staff.page').then((m) => m.StaffPage),
    canActivate: [authGuard],
  },
  {
    path: 'equipos',
    loadComponent: () => import('./pages/equipos/equipos.page').then((m) => m.EquiposPage),
    canActivate: [authGuard],
  },
  {
    path: 'reportes',
    loadComponent: () => import('./pages/reportes/reportes.page').then((m) => m.ReportesPage),
    canActivate: [authGuard],
  },
  {
    path: 'portal-medico',
    loadComponent: () => import('./pages/doctor-portal/doctor-portal.page').then((m) => m.DoctorPortalPage),
    canActivate: [authGuard, doctorGuard],
  },
  {
    path: 'equipment-detail/:id',
    loadComponent: () => import('./pages/equipment-detail/equipment-detail.page').then((m) => m.EquipmentDetailPage),
    canActivate: [authGuard],
  },
  {
    path: 'equipment/:id/checklist-history',
    loadComponent: () =>
      import('./pages/rentas/equipment-checklist-history/equipment-checklist-history.page').then(
        (m) => m.EquipmentChecklistHistoryPage,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'start-procedure/:id',
    loadComponent: () => import('./pages/start-procedure/start-procedure.page').then((m) => m.StartProcedurePage),
    canActivate: [authGuard],
  },
  {
    path: 'procedimientos',
    loadComponent: () => import('./pages/procedimientos/procedimientos.page').then((m) => m.ProcedimientosPage),
    canActivate: [authGuard],
    data: { shouldReuseRoute: false },
  },
  {
    path: 'procedimientos/:id',
    loadComponent: () => import('./pages/procedimientos/procedimientos.page').then((m) => m.ProcedimientosPage),
    canActivate: [authGuard],
    data: { shouldReuseRoute: false },
  },
  // Redirects
  {
    path: '**',
    redirectTo: 'procedimientos',
  },
];
